module.exports = __webpack_public_path__ + "img/EN-注册３.150f16be.png";